/**
 * Skills tab configuration for the Service Provider Skills flow:
 * REST endpoints and UI flags/messages.
 *
 * Keys under `config.api` / `config.ui.messages` must match what Skills
 * components read (e.g. IndustriesServicedSelector → `industriesServicedSelector`).
 */

function serviceProviderBase(apiBaseUrl, serviceProviderId) {
  return `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}`;
}

function getConfig({ apiBaseUrl, serviceProviderId }) {
  const sp = serviceProviderBase(apiBaseUrl, serviceProviderId);
  const emailUrl = `${sp}/notifications/emails`;
  const phonesUrl = `${sp}/notifications/phones`;

  return {
    api: {
      industriesServicedSelector: {
        listBoxLeft: `${sp}/allowed-industries`,
        listBoxRight: `${sp}/service-industries`,
        listBoxAdd: `${sp}/service-industries/bulk-create`,
        listBoxRemove: `${sp}/service-industries/bulk-delete`,
      },
      industriesServiced: {
        fetch: `${sp}/service-industries`,
      },
      productLinesSelector: {
        listBoxLeft: `${sp}/product-lines`,
        listBoxRight: `${sp}/excluded-product-lines`,
        listBoxAdd: `${sp}/excluded-product-lines/bulk-create`,
        listBoxRemove: `${sp}/excluded-product-lines/bulk-remove`,
      },
      brandsSelector: {
        listBoxLeft: `${sp}/brands`,
        listBoxRight: `${sp}/excluded-brands`,
        listBoxAdd: `${sp}/excluded-brands/bulk-create`,
        listBoxRemove: `${sp}/excluded-brands/bulk-remove`,
      },
      setup: {
        emailUrl,
        phonesUrl,
        deleteSelectedPhones: `${phonesUrl}/operation/bulk-delete`,
        exportPhones: `${phonesUrl}/operation/export`,
      },
      claimSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/claims`,
      dispatchSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/dispatch`,
      insightSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/insight`,
      apiKeysSettingsApiUrl: `${apiBaseUrl}/sxcl/v1/service-provider-profile/${serviceProviderId}/api-keys`,
      rateCardApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}`,
      performanceApiUrl: `${apiBaseUrl}/sxcl/v1/service-providers/${serviceProviderId}/performance`,
    },
    ui: {
      messages: {
        industriesServicedSelector: {
          leftTitle: {
            id: 'INDUSTRIES_LIST',
            defaultMessage: 'Industries List',
          },
          rightTitle: {
            id: 'INDUSTRIES_SERVICED',
            defaultMessage: 'Industries Serviced',
          },
          saveSuccess: {
            id: 'SERVICE_PROVIDER_INDUSTRIES_WERE_SAVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider industries were saved successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_INDUSTRIES_WERE_REMOVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider industries were removed successfully',
          },
        },
        productLinesSelector: {
          saveSuccess: {
            id: 'SERVICE_PROVIDER_PRODUCT_LINES_EXCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Product lines excluded successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_PRODUCT_LINES_INCLUDED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider Product lines included successfully',
          },
        },
        brandsSelector: {
          saveSuccess: {
            id: 'SERVICE_PROVIDER_BRANDS_EXCLUDED_SUCCESSFULLY',
            defaultMessage: 'Service Provider Brands excluded successfully',
          },
          removeSuccess: {
            id: 'SERVICE_PROVIDER_BRANDS_INCLUDED_SUCCESSFULLY',
            defaultMessage: 'Service Provider Brands included successfully',
          },
        },
        setup: {
          emailSaveSuccess: {
            id: 'SERVICE_PROVIDER_DISPATCH_NOTIFICATIONS_SAVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider dispatch notifications saved successfully',
          },
          emailSaveWarning: {
            id: 'SERVICE_PROVIDER_DISPATCH_NOTIFICATIONS_SAVED_WITH_WARNINGS',
            defaultMessage:
              'Service Provider dispatch notifications saved with warnings',
          },
          phonesSaveSuccess: {
            id: 'SERVICE_PROVIDER_CUSTOMER_COMMUNICATION_SAVED_SUCCESSFULLY',
            defaultMessage:
              'Service Provider customer communication saved successfully',
          },
          phonesSaveWarning: {
            id: 'SERVICE_PROVIDER_CUSTOMER_COMMUNICATION_SAVED_WITH_WARNINGS',
            defaultMessage:
              'Service Provider customer communication saved with warnings',
          },
        },
      },
    },
  };
}

export default getConfig;
